import * as React from "react";
import { isAndroid, isIOS, isMobile } from "react-device-detect";
import { RouteComponentProps } from "react-router-dom";
import config from "../config";
import IArticle from "../types/IArticle";
import { mpGetDistinctId } from "../utils/mixpanel";
import responseCheck from "../utils/response-check";
import { getQueryString } from "../utils/url";

interface IState {
  article?: IArticle;
}

interface IQSParams {
  key: string;
  id: string;
  bgColor: string;
  color: string;
  listenColor: string;
  controlColor: string;
}

class EmbedPlayerWrapper extends React.Component<RouteComponentProps, IState> {

  public LazyEmbedPlayer = React.lazy(() => import("./EmbedPlayer"));

  constructor(props: any) {
    super(props);

    this.state = {
      article: null,
    };
  }

  public getQueryParams = (): IQSParams => {

    const pathname = window.location.search;
    const queries = getQueryString(pathname);
    const key = queries.key || "";
    const id = queries.id || "";
    const color = queries.color || "";
    const bgColor = queries.bgColor || "";
    const listenColor = queries.listenColor || "";
    const controlColor = queries.controlColor || "";

    return { key, id, color, bgColor, listenColor, controlColor };
  }

  public getVersion = (): number => {

    const pathname = this.props.location.pathname.toLowerCase();

    if (pathname === "/v1") { return 1; }
    if (pathname === "/v2") { return 2; }
    if (pathname === "/v3") { return 3; }
    if (pathname === "/v4") { return 4; }

    return 1;
  }

  public getEmbedArticle = (publisherCode: string, articleCode: string) => {

    const requestUrl = `${config.api.url}${config.api.routes.articlePlayer}?code=${articleCode}`;
    const headers = {
      authorization: publisherCode,
    };

    return fetch(requestUrl, { headers })
      .then(responseCheck)
      .then((response) => {

        if (!!response && !!response.data && !!response.data.article) {
          const article: IArticle = response.data.article;
          this.setState({ article });
        }
      })
      .catch((error) => this.articleFailure(error));
  }

  public articleFailure = (error: Error) => {
    // tslint:disable-next-line: no-console
    console.error(error);
  }

  public getLinkToNoa = (publisherKey: string) => {
    const { article } = this.state;

    if (!article) {
      return config.site.url;
    }

    if (publisherKey === config.embed.publishers.hbr) {
      return `${config.site.url}/publishers/${article.publisher.id}?mpId=${mpGetDistinctId()}`;
    }

    if (isIOS) {
      return config.appStore.ios;
    }

    if (isAndroid) {
      return config.appStore.android;
    }

    return `${config.site.url}/publishers/${article.publisher.id}?mpId=${mpGetDistinctId()}`;
  }

  public getSubtitle = () => {

    const { article } = this.state;

    return article
      ? `${article.publisher.name} • ${Array.isArray(article.journalists) && article.journalists.length > 0
        ? article.journalists[0].name
        : ""
      }`
      : "";
  }

  public componentDidMount() {

    const params = this.getQueryParams();
    this.getEmbedArticle(params.key, params.id);
  }

  public render() {

    const article = this.state.article;
    const { color, bgColor, key, listenColor, controlColor } = this.getQueryParams();
    this.getVersion();

    return (
      <React.Suspense fallback={<></>}>
        {!!article &&
          <this.LazyEmbedPlayer
            publisherKey={key}
            queryParams={window.location.search}
            version={this.getVersion()}
            title={article.name}
            audioUrl={article.audio}
            feedbackEmail="feedback@newsoveraudio.com"
            linkToNoa={this.getLinkToNoa(key)}
            noaUrl={config.site.url}
            subtitle={this.getSubtitle()}
            metricName={`articles-${article.id}`}
            color={color}
            bgColor={bgColor}
            listenColor={listenColor}
            controlColor={controlColor}
            article={this.state.article}
          />
        }
      </React.Suspense>
    );
  }

}

export default EmbedPlayerWrapper;
